import { TextField } from '@material-ui/core';
import React from 'react';
export const RenderInput = (props) => {
    const { className, label, placeholder } = props;
    return (params) => {
        const inputPropsClassName = params.inputProps.className ? `${params.inputProps.className} ${className}` : className;
        params.inputProps = Object.assign(Object.assign({}, params.inputProps), { className: inputPropsClassName });
        return (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, label: label, placeholder: placeholder, InputProps: params.InputProps })));
    };
};
//# sourceMappingURL=RenderInput.js.map